import styled from "styled-components";

export const PageOuter = styled.div`
  max-width: 1100px;
  width: 100%;
  margin: 60px auto 60px;
  padding: 0 var(--container-pad);

  @media (max-width: 600px) {
    margin: 32px auto 40px;
  }
`;

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const HeroBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  background: var(--color-primary-soft);
  color: var(--color-primary);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  border-radius: 999px;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: clamp(28px, 4vw, 44px);
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.5px;
  color: var(--color-text);
  max-width: 900px;
`;

export const Accent = styled.div`
  width: 56px;
  height: 4px;
  background: var(--color-primary);
  border-radius: 999px;
`;

export const SliderBlock = styled.div`
  width: 100%;
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow-lg);

  .swiper {
    border-radius: var(--radius-xl);
  }

  .swiper-pagination-bullet {
    background: white;
    opacity: 0.7;
  }

  .swiper-pagination-bullet-active {
    background: var(--color-primary);
    opacity: 1;
    width: 22px;
    border-radius: 999px;
  }
`;

export const SliderImg = styled.img`
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  display: block;

  @media (max-width: 600px) {
    aspect-ratio: 4 / 3;
  }
`;

export const HeroImageWrap = styled.div`
  width: 100%;
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow-lg);
  position: relative;

  &::after {
    content: "";
    position: absolute;
    inset: auto 0 0 0;
    height: 30%;
    background: linear-gradient(to top, rgba(26, 31, 21, 0.25), transparent);
    pointer-events: none;
  }
`;

export const HeroImage = styled.img`
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  display: block;

  @media (max-width: 600px) {
    aspect-ratio: 4 / 3;
  }
`;

export const ContentCard = styled.article`
  background: white;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  padding: 44px 52px;
  box-shadow: var(--shadow-sm);

  @media (max-width: 768px) {
    padding: 28px 22px;
  }
`;

export const Paragraph = styled.p`
  font-size: 17px;
  font-weight: 400;
  line-height: 1.75;
  color: var(--color-text);
  margin: 0 0 18px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const LeadParagraph = styled(Paragraph)`
  font-size: 19px;
  font-weight: 500;
  color: var(--color-text);
  padding-left: 16px;
  border-left: 3px solid var(--color-primary);
  margin-bottom: 24px;

  @media (max-width: 600px) {
    font-size: 17px;
    padding-left: 12px;
  }
`;

export const DynamicPageContainer = PageOuter;
export const MainText = Paragraph;
export const SliderDynamicComponent = SliderBlock;
